export const HeaderContainer = {
  "Notification": "Notification",
  "Print": "Print",
  "Save": "Save",
  "untitled": "untitled",
  "ShareBtn": "Share",
  "InstallApp": "Install",
  "DownloadApp": "Download",
  "InstallTooltip": "Add Foxit PDF Editor Cloud to your Desktop / Editor Cloud can be set as the default PDF viewer.",
  "EditorCloudDefaultViewerTooltip": "Set Foxit PDF Editor Cloud as the default PDF viewer.",
  "InstallEditorCloudMainTip": "Foxit PDF Editor Cloud will be your default PDF viewer after you download and install the package.",
  "InstallEditorCloudSubTip": "Tip: Please note that the feature may not be available in all browsers, such as Safari.",
  "CreateDropdown": {
    "OpenFile": "Open File",
    "CreatePDF": "Create a pdf"
  },
  "localLang": "The language of your current area: ",
  "isChangeTo": "Do you want to switch the language to: ",
  "changTo": "Switch to: ",
  "BackHome": "Back to homepage",
  "BackToSharePoint": "Back to { fromDrive }",
  "Secured": "(SECURED)",
  "SaveSameSource": "Save the PDF file with your latest changes to the source path",
  "SaveAsCNAreaTooltip": "Save the PDF file with your latest changes",
  "switchLaguage": "Switch language",
  "helpMenu": {
    "getHelp": "Get help",
    "shareFeedback": "Share feedback",
    "termsOfService": "Terms of Service",
    "serviceStatus": "Service Status",
    "privacyPolicy": "Privacy Policy",
    "contactUs": "Contact us",
    "whatsNew": "What's new",
    "about": "About"
  },
  "customToolbar": "Customize Quick Access Toolbar",
  "customOpen": "Open",
  "customCreate": "Create PDF",
  "customCreateBlank": "Blank",
  "customSaveAs": "Save As",
  "undo": "Undo",
  "redo": "Redo",
  "PluginInstallDlg": {
    "title": "lnstall Foxit PDF Editor app",
    "onlinePWA": "Once installed, you may open Foxit PDF Editor Cloud as a desktop application.",
    "onlineExe": "Once installed, Foxit PDF Editor Cloud will be your default PDF viewer.",
    "onlineExeTip": "Tip: Some browsers may not support this app, such as Safari."
  },
  "InstallPWADlg": {
    "title": "Foxit PDF Editor Cloud",
    "p_1": "To set this desktop application as a default viewer:",
    "p_2": "1. Enter <a href='about://flags' target='_blank' class='c0099FF'>about://flags</a> in your Brower.",
    "p_3": "2. Enter <span class='c0099FF'>#file-handling-api</span> in the Search Bar.",
    "p_4": "3. Click <span class='c0099FF'>Enabled</span> Button of \"File Handling Api\".",
    "p_5": "Note: This setting supports Edge, Chrome and other browsers, and requires the browser kernel to be Chromium 94 and above.",
    "NotShow": "Don't show again",
    "got": "Got It"
  },
  "SwitchToEditorDesktop": "Edit with Editor Desktop",
  "openingLoading": "Opening ...",
  "savingLoading": "Saving ...",
  "Languages": "Languages",
  "saveToLocalTip": "Save your latest changes to local computer",
  "downloadFile": "Download File",
  "uploadLocalFileToFoxitDocumentTip": "Upload the local file to the Cloud Documents",
  "titleEditor": "Foxit PDF Editor Cloud",
  "titleReader": "Foxit PDF Reader",
  "startEditorCloudAppTip": "The function needs to launch Foxit Editor Cloud Application to switch current opened file to Editor Windows. Do you want to continue?",
  "startEditorCloudAppTipForSave": "The function needs to launch Foxit Editor Cloud Application to save your latest changes to local computer. Do you want to continue?",
  "startEditorCloudConfirmBtn": "Start Now",
  "downloadAppContent": "To open the file in {type}, please make sure you have installed the latest version.",
  "downloadAppConfirmBtn": "Download Now",
  "updateEditorCloudAppBtn": "Update Now",
  "downloadEditorCloudAppTip": "This version of Foxit Editor Cloud Application is no longer supported. Please update to the latest version of the application and reopen the document.",
  "EditorCloudAppErrorMsg": {
    "openSuccessMsg": "File opened successfully.",
    "saveSuccessMsg": "File saved successfully.",
    "fileNotExist": "The file does not exist. Please check and try again.",
    "openFileFailedOfFileOccupiedByOtherApplication": "Failed to open the file. It may be occupied by other programs. Please confirm the check and try to save again.",
    "saveFileFailedOfFileOccupiedByOtherApplication": "Failed to save the file. It may be occupied by other programs. Please confirm the check and try to save again.",
    "openFailedMsg": "Failed to open the file.",
    "saveFailedMsg": "Failed to save the file.",
    "applicationNotExit": "The application {type} doesn't exist, please install and try again."
  },
  "Origin": {
    "local": "Opened from Local Computer",
    "box": "Opened from Box",
    "dropBox": "Opened from Drop box",
    "googleDrive": "Opened from Google Drive",
    "iManage": "Opened from iManage 10",
    "oneDrive": "Opened from OneDrive",
    "sharePoint": "Opened from SharePoint",
    "storage": "Opened from Cloud Documents"
  }
}